export default __webpack_public_path__ + "static/media/domino_counter_screen_4.95994a78.png";